if(!customElements.get('product-columns-block')) {
    class ProductColumnsBlock extends HTMLElement {
        constructor() {
            super();
        }
        
        connectedCallback() {
            this.swiperContainer = this.querySelector('.swiper-container:not(.swiper-container--product-card)');
            this.initializeSwiper();
        }

        async initializeSwiper() {
            if(!this.swiperContainer) return;

            const slides = this.swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide--product-card)');
            if(slides.length <= 1) return;

             if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const itemsPerView = parseInt(this.swiperContainer.dataset.itemsPerView);
            const itemsPerViewMobile = parseInt(this.swiperContainer.dataset.itemsPerViewMobile);
            const totalSlides = parseInt(this.swiperContainer.dataset.itemsTotal);

            const autoplay = this.swiperContainer.dataset.autoplay === 'true';
            const speed = parseInt(this.swiperContainer.dataset.speed);
            const loop = this.swiperContainer.dataset.loop === 'true';
            const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
            const spaceBetween = parseInt(this.swiperContainer.dataset.gap);

            const breakpoints = {
                0: { slidesPerView: itemsPerViewMobile },
                768: { slidesPerView: visibleItemsPerView }
            }

             var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false,
                spaceBetween: spaceBetween,
                on: {
                    init: () => {
                        const paginationBullets = this.swiperContainer.querySelectorAll(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet");
                        if(paginationBullets.length > 0){
                            this.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                            paginationBullets.forEach((item, index) => {
                                item.setAttribute('data-index', `${index}`);
                            });
                            setTimeout(() => {
                                this.swiperContainer.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')?.classList.add('loaded');
                                this.checkSwiperLock();
                            }, 500);
                        }
                    },
                    slideChange: () => {
                        const activePagination = this.swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    },
                    resize: () => {
                        const activePagination = this.swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    }
                }
            }

            if(this.swiperContainer.querySelector(".swiper-navigation-wrapper:not(.swiper-navigation-wrapper--product-card)")){
                swiperSettings.navigation = {
                    nextEl: this.swiperContainer?.querySelector('.button-next:not(.button-next--product-card)'),
                    prevEl: this.swiperContainer?.querySelector('.button-previous:not(.button-previous--product-card)')
                }
            }

            if(this.swiperContainer.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')){
                swiperSettings.pagination = {
                    el: this.swiperContainer.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')
                }
            }

            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            const swiper = new Swiper(this.swiperContainer, swiperSettings);
            swiper.init();

            swiper.on("resize", this.checkSwiperLock.bind(this, this.swiperContainer, swiper));

            this.setupFocusListeners();
        }


        checkSwiperLock(swiperContainer, swiper){
            if(!swiperContainer || !swiper) return;
            if(!swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)")) return;
            
            if(swiper.isLocked){
                swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.add('hidden');
            }else{
                swiperContainer.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.remove('hidden');
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next:not(.button-next--product-card), .button-previous:not(.button-previous--product-card)").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('product-columns-block', ProductColumnsBlock);
}